import EntryPoint from '../../EntryPoint';

export default new class MoneyFormat {
    format(value, showCurrency = true, hideFractionIfPossible) {
        let text = this.formatCurrency(value, EntryPoint.GameModel.currencyInfo.decimals, hideFractionIfPossible);
        if (showCurrency) {
            text = `${text} ${EntryPoint.GameModel.currencyInfo.symbol}`;
        }

        return text;
    }

    formatCurrency(value, decimals, hideFractionIfPossible = true) {
        return OPUtility.utils.format(value, decimals, hideFractionIfPossible);
    };
}
